// ** MUI Imports
import { Theme } from '@mui/material/styles';

const input = (theme: Theme) => {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'var(--c-text)',
          fontSize: 13,
          marginBottom: 4
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: true,
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#C5C7CD',
        },
      },
    },
  };
};

export default input;
